import { OrderCostSummaryV2PdfProps } from "../index";
import React, { ReactNode } from "react";
import { Text, View } from "@react-pdf/renderer";

interface Props {
  styles: OrderCostSummaryV2PdfProps['styles'];
  label: string;
  value: string | number;
  highlight?: boolean;
}

const LineItem = (props: Props) => {
  const { styles, label, value, highlight = false } = props;

  return (
    <View style={highlight ? styles.footerHighlight : styles.footer}>
      <View style={styles.footerTitles}>
        <Text>{label}</Text>
      </View>

      <View style={styles.footerCosts}>
        <Text>{value}</Text>
      </View>
    </View>
  )
}

export default LineItem;
